//@flow
import React from 'react';
import FilterItem from './Filter.react';
import FilterList from './FilterList.react';
import _ from 'underscore';
import type { Filter, FilterKey, FilterCategories } from '../../Stores/Filters/filtersStoreClass';

function _filterIsChecked(filter:string, selectedFilters:Filter[]) {
  return selectedFilters.findIndex(selected => selected.name === filter) !== -1;
}

function _renderFilterListItems(filters:{[FilterKey]:string}, selectedFilters:Filter[], filterType:string) {
  return Object.keys(filters).map(filter => {
    const text = filters[filter];
    return (
      <FilterItem
        checked={_filterIsChecked(filter, selectedFilters)}
        key={filter}
        name={filter}
        text={text}
      >
        <span className="filter-name">{text}</span>
      </FilterItem>
    );
  });
}

function _renderFilterLists(props:Props) {
  const {
    filters,
    selectedFilters,
    controlId,
  } = props;
  return _.map(filters, (allFilters, filterType) => (
    <FilterList
      key={filterType}
      name={filterType}
      initialShowList={filterType === 'NUTRITION'}
      controlId={controlId}
    >
      {_renderFilterListItems(allFilters, selectedFilters, filterType)}
    </FilterList>
  ));
}

type Props = {
  filters:FilterCategories,
  selectedFilters:Filter[],
  controlId?:string,
};

export default function FilterLists(props:Props) {
  return (
    <div className="fiter-lists">
      {_renderFilterLists(props)}
    </div>
  );
}
